import React from "react"
import { Link } from "react-router-dom"
import { ChevronLeft } from "lucide-react"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator
} from "../../../ui/bread-crumb"

const TopicPageLayout = ({ title, description, icon, children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FDF8FF] to-white">
      <div className="container mx-auto px-4 py-8 md:py-12">
        {/* Breadcrumbs Navigation */}
        <Breadcrumb className="mb-6">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/helpdesk">Helpdesk</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink>{title}</BreadcrumbLink>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        {/* Back to Help Center Link */}
        <Link
          to="/helpdesk"
          className="inline-flex items-center text-[#3D2A60] hover:text-[#E563A4] transition-colors mb-6"
        >
          <ChevronLeft className="h-4 w-4 mr-1" />
          Back to Help Center
        </Link>

        {/* Topic Header */}
        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 mb-8">
          <div className="w-16 h-16 rounded-full bg-[#F4F0FA] flex items-center justify-center flex-shrink-0">
            {icon}
          </div>

          <div className="text-center md:text-left">
            <h1 className="text-3xl md:text-4xl font-bold mb-3 text-[#3D2A60]">
              {title}
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl">{description}</p>
          </div>
        </div>

        {/* Topic Content */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8">
          {children}
        </div>
      </div>
    </div>
  )
}

export default TopicPageLayout
